let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '站点',
        props: 'stationName',
        minWidth: 200,
    },
    {
        label: '充电桩IMEI码',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '订单编号',
        props: 'orderNo',
        minWidth: 300,
        tooltip:true,
    },
    {
        label: '用户手机号',
        props: 'custPhone',
        minWidth: 200,
    },
    {
        label: '订单类型',
        props: 'sourceName',
        minWidth: 200,
    },
    {
        label: '订单状态',
        props: 'chargeStepName',
        minWidth: 200,
        // formatter: function formatter(row, column, cellValue, index) {
        //     if(row.chargeStepCode == '01'){
        //         return '开始充电'
        //     }else{
        //         return '结束充电'
        //     }
        // }
    },
    {
        label: '订单属性',
        props: 'orderPropertyName',
        minWidth: 120,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.orderProperty) {
                if(row.orderProperty == '01'){
                    return '正常'
                }else{
                    return '异常'
                }
            }
            else {
                return ''
            }
        }
    },
    {
        label: '开始时间',
        props: 'beginTime',
        minWidth: 200,
    },
    {
        label: '结束时间',
        props: 'endTime',
        minWidth: 200,
    },
    {
        label: '充电日期',
        props: 'chargeDay',
        minWidth: 200,
    },
    {
        label: '充电时长',
        props: 'chargSeconds',
        sortable:true,
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
             //做判断
            if (row.chargSeconds) {
                return Math.floor(row.chargSeconds / 60) + '分' + Math.floor(row.chargSeconds % 60) + '秒'
            }
        }
    },
    {
        label: '充电量（kW·h）',
        props: 'chargeVal',
        minWidth: 180,
    },
    {
        label: '单价(元/度)',
        props: 'ttlVal',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.ttlVal) {
                return row.ttlVal
            }
            else {
                return '0'
            }
        }
    },
    {
        label: '订单金额（元）',
        props: 'tActFee',
        minWidth: 180,
    },
    {
        label: '私人/公共',
        props: 'pileTypeName',
        minWidth: 200,
    },
    {
        label: '交流/直流',
        props: 'currentOutTypeName',
        minWidth: 200,
    },
    {
        label: '枪头',
        props: 'gunPort',
        minWidth: 200,
    },
    {
        label: '桩型号',
        props: 'pileTypeNo',
        minWidth: 180,
    },
    {
        label: '厂商标识',
        props: 'manufactureMark',
        minWidth: 180,
    },
    {
        label: '启动方式',
        props: 'sourceName',
        minWidth: 180,
    },
    {
        label: '桩软件版本',
        props: 'softVersion',
        minWidth: 180,
    },
    {
        label: '桩到家抵扣度电(kW·h)',
        props: 'deductionElec',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.deductionWay == '01') {
                return '不抵扣';
            }else if(row.deductionWay == '02'){
                return row.deductionElec;
            }else{
                return '-';
            }
        }
    },
    {
        label: '服务商抵扣度电(kW·h)',
        props: 'tActFee',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.deductionWay == '01') {
                return '不抵扣';
            }else if(row.deductionWay == '03'){
                return row.deductionElec;
            }else{
                return '-';
            }
        }
    },
    {
        label: '实付度电(kW·h)',
        props: 'needEectric',
        minWidth: 180,
    },
    {
        label: '实付金额(元)',
        props: 'actPayFee',
        minWidth: 180,
    },
    {
        label: '支付状态',
        props: 'payStatusName',
        minWidth: 180,
        // formatter: function formatter(row, column, cellValue, index) {
        //     // 做判断
        //     if (row.payStatus) {
        //         if(row.payStatus == '01'){
        //             return '待支付'
        //         }else{
        //             return '已支付'
        //         }
        //     }
        //     else {
        //         return ''
        //     }
        // }
    },
    {
        label: '用户评价',
        props: '',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
                if(row.appraiseCode == '02'){
                    return '不满意'
                }else if(row.appraiseCode == '01'){
                    return '满意'
                }else{
                    return '未评价'
                }
        }
    },
    // {
    //     label: '备注',
    //     props: 'lastModifiedWhen',
    //     minWidth: 180,
    // },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '订单管理'
}];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'orderManageList';

pageConfig.orderDeatilRouter = 'orderDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '订单管理',
    router: 'orderManageList'
},
{
    type: 'title',
    name: '订单详情',
}];

pageConfig.formRules = {
    pileTypeName: [{
        required: true,
        message: '请填写充电桩型号名称',
        trigger: 'blur'
    }],
};

pageConfig.orderFormRules = {
    chargeOverReason: [{
        required: true,
        message: '请填写结束充电原因',
        trigger: 'change'
    }]
};

export default pageConfig;
